<template>
  <div id="certificados">
    <div id="certificados-list" v-if="listing===true">

      <div id="certificados-actions" class="row-flex">
        <div class="col-12">
          <h2 class="vp-h2 vp-module-heading">
            Certificados
          </h2>
          <router-link to="/novo" class="btn vp-btn vp-new-btn botao-novo" ><i class="fa fa-fw fa-plus"></i> Novo certificado</router-link>
        </div>
      </div>

      <div id="certificados-items" class="row-flex">
        <div class="col-12 small-6 mid-4 cert-item" v-for="certificado in certificados">
          <div class="card-box">
            <div class="type-label evento" :class="certificado.tipo">
              <i class="fa fa-fw fa-certificate" title="Certificado do evento" v-if="certificado.tipo==='evento'"></i>
              <i class="fa fa-fw fa-tasks" title="Certificado da atividade" v-else-if="certificado.tipo==='atividade'"></i>
              <i class="fa fa-fw fa-file" title="Certificado da trabalho" v-else-if="certificado.tipo==='trabalho'"></i>
            </div>
            <h4>{{certificado.nome}}</h4>
            <div class="card-data row-flex">
              <div class="col-12 col status" :class="(certificado.ativo==='1' ? 'ativo' : 'nao-ativo')">
                <span v-on:click="handleCertificateActivationStatus(certificado)" v-tooltip.top="{content: '<strong>Clique para '+(certificado.ativo==='1' ? 'desativar' : 'ativar')+' o certificado</strong>'}">
                  <i class="fa fa-fw fa-circle"></i>
                  <span v-if="certificado.ativo==='1'">Ativo</span>
                  <span v-if="certificado.ativo==='0'">Desativado</span>
                </span>
              </div>
              <!-- <div class="col-6 col formato">
                <strong>Formato:</strong> <span>{{certificado.configs.formato}}</span>
              </div>
              <div class="col-6 col formato">
                <strong>Assinaturas:</strong> <span>{{certificado.configs.assinaturas.length}}</span>
              </div>
              <div class="col-12" v-if="certificado.tipo==='evento'">
                <div class="row-flex">
                  <div class="col-6">
                  </div>
                </div>
              </div>
              <div class="col-12" v-if="certificado.tipo==='atividade'">
                <div class="row-flex">
                </div>
              </div> -->
            </div>
            <div class="card-footer row-flex">
              <div class="col-12 small-6 grow">
                <div class="row-flex">
                  <router-link class="btn vp-flat-btn vp-edit-btn" :to="'/'+certificado.id">Editar</router-link>
                </div>
              </div>
              <div class="col-12 small-6 grow">
                <div class="row-flex">
                  <a href="javascript:void(0)" class="btn vp-flat-btn vp-delete-btn" v-on:click="deleteCertificado(certificado.id)">Remover</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import vSelect from 'vue-select'
  import vTooltip from 'v-tooltip'
  import Vodal from 'vodal'
  // import Buefy from 'buefy'
  // import 'buefy/lib/buefy.css'

  import "vodal/common.css"
  import "vodal/flip.css"
  import "vodal/slide-up.css"

  Vue.use(vTooltip)
  Vue.component(Vodal.name, Vodal)
  //Vue.use(Buefy)

  export default {
    name: 'app',
    components: {
      vSelect
    },
    data () {
      return {
        certificados: [],
        listing: true,
        activeCert: null,
        certificadoAtivoDoEvento: null
      }
    },
    computed: {
      url: function () {
        return url
      },
      veryFirstTime: function () {
        if(this.certificados.length > 0) return false
        return true
      },
      eid() {
        return eid
      }
    },
    created: function () {
      this.urlAdmin = url;
    },
    mounted: function () {
      this.getCertificados();
    },
    methods: {
      getCertificados: function () {
        Promise.all([
          this.$http.post(url+'admin/includes/newApi.php', {
            type: "certificates",
            method: "GET",
            id: null
          }),
          this.$http.post(url+'admin/includes/newApi.php', {
            type: "certificado_de_evento_ativo",
            eid: eid
          })
        ])
        .then(resp => {
          this.certificados = resp[0].data
          if (resp[1].data !== false) {
            this.certificadoAtivoDoEvento = resp[1].data.id
          } else {
            this.certificadoAtivoDoEvento = '-1'
          }
          return 'ok'
        })
      },
      deleteCertificado: function (id) {
        let self = this
        swal({
          title: 'Você tem certeza?',
          text: 'Deseja mesmo deletar este certificado? Esta ação será definitiva e não poderá ser revertida!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#e74c3c',
          confirmButtonText: 'Sim, remover',
          cancelButtonColor: '#3498db',
          cancelButtonText: 'Cancelar',
          closeOnConfirm: false
        },
        function(){
          self.$http.post(url+'admin/includes/newApi.php', {
            type: 'certificates',
            method: 'DELETE',
            id: id
          })
          .then(resp => {
            if(resp.data===true){
              swal('Sucesso', 'Seu certificado foi removido com sucesso', 'success')
              self.getCertificados()
            }
          })
        });
      },
      handleCertificateActivationStatus: function (certificado) {
        let self = this
        let promise = []
        let action = certificado.ativo

        let catchErrorMsg = function () {
          swal({
            title: 'Ocorreu um erro',
            text: 'Pode haver um erro com a sua conexão com a internet ou com nossos servidores. Tente novamente mais tarde. Se o erro persistir, por favor, entre em contato.',
            type: 'error',
            showCancelButton: false,
            confirmButtonColor: '#e74c3c',
            confirmButtonText: 'Fechar',
          })
        }
        let thenSuccessMsg = function () {
          swal({
            title: 'Sucesso',
            text: 'O certificado "'+certificado.nome+'" foi '+(action==='0' ? 'ativado' : 'desativado')+' com sucesso!',
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          })
          self.getCertificados()
        }

        if (certificado.ativo === '0' && certificado.tipo === 'evento' && self.certificadoAtivoDoEvento !== '-1') {

          swal({
            title: 'Tem certeza?',
            text: 'Você só pode ter apenas UM certificado ativo por evento. Portanto, o certificado usado para o evento atualmente será desativado para que "'+certificado.nome+'" fique ativo. Deseja mesmo prosseguir?',
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Sim, alterar',
            confirmButtonColor: '#3498db',
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
            allowOutsideClick: true
          }, function () {
            self.$http.post(url+'admin/includes/newApi.php', {
              type: "activate_event_certificate",
              id: certificado.id,
              eid: self.eid
            })
            .catch(catchErrorMsg)
            .then(thenSuccessMsg)
          })
        } else if (certificado.ativo === '1') {
          swal({
            title: 'Tem certeza?',
            text: 'Deseja mesmo desativar "'+certificado.nome+'"?',
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Sim, alterar',
            confirmButtonColor: '#34495e',
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
            allowOutsideClick: true
          }, function () {
            self.$http.post(url+'admin/includes/newApi.php', {
              type: "deactivate_certificate",
              id: certificado.id
            })
            .catch(catchErrorMsg)
            .then(thenSuccessMsg)
          })
        } else if (certificado.ativo === '0') {
          swal({
            title: 'Tem certeza?',
            text: 'Deseja mesmo ativar "'+certificado.nome+'"?',
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Sim, alterar',
            confirmButtonColor: '#34495e',
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
            allowOutsideClick: true
          }, function () {
            self.$http.post(url+'admin/includes/newApi.php', {
              type: "activate_certificate",
              id: certificado.id
            })
            .catch(catchErrorMsg)
            .then(thenSuccessMsg)
          })
        }

      }
    }
  }
</script>


<style type="text/css">
  .botao-novo {
    margin-bottom: 10px;
  }
  .vp-flat-btn {
    text-transform: uppercase;
    padding: 10px 15px;
  }
  @media (max-width: 767px) {
    .vp-flat-btn {
      margin-bottom: 0;
    }
  }

  #certificados-items .cert-item {
    margin-bottom: 15px;
  }
  #certificados-items .card-box {
    display: flex;
    flex-direction: column;
    padding: 15px;
    height: 100%;
    position: relative;
    background-color: #FFF;
    text-align: left;
    border-radius: 0;
    -webkit-box-shadow: 0px 0px 20px -5px rgba(120,120,120,0.4);
    -moz-box-shadow: 0px 0px 20px -5px rgba(120,120,120,0.4);
    box-shadow: 0px 0px 20px -5px rgba(120,120,120,0.4);
  }
  #certificados-items .card-box .type-label::before {
    content: '';
    border-width: 0 50px 50px 0;
    border-style: solid;
    border-bottom-color: transparent;
    position: absolute;
    top: 0;
    right: 0;
  }
  #certificados-items .card-box .type-label i {
    color: #FFF;
    position: absolute;
    top: 7.5px;
    right: 2px;
    font-size: 18px;
    transition: all 0.3s ease-in;
  }
  #certificados-items .card-box .type-label.evento::before {
    border-right-color: #3498db;
  }
  #certificados-items .card-box:hover .type-label.evento::before {
    border-right-color: #2980b9;
  }
  #certificados-items .card-box .type-label.atividade::before {
    border-right-color: #e67e22;
  }
  #certificados-items .card-box:hover .type-label.atividade::before {
    border-right-color: #d35400;
  }

  #certificados-items .card-box .card-data {
    margin-top: auto;
    padding: 5px 0 15px;
  }
  #certificados-items .card-box .card-data > .col {
    padding-top: 2.5px;
    padding-bottom: 2.5px;
    font-size: 12px;
  }
  #certificados-items .card-box .card-data .status {
    font-weight: 700;
    font-size: 14px;
  }
  #certificados-items .card-box .card-data .status span {
    cursor: pointer;
  }
  #certificados-items .card-box .card-data .status.ativo span {
    color: #2ecc71;
  }
  #certificados-items .card-box .card-data .status.nao-ativo span {
    color: #e74c3c;
  }

  /*#certificados-items .card-box .card-data .formato {
    text-transform: capitalize;
  }*/

  #certificados-items .card-box .card-footer {
    /*margin-top: auto;*/
    border-top: 1px solid #eaeaea;
    /*padding-top: 15px;*/
    margin-bottom: -15px;
  }
  #certificados-items .card-box .card-footer a {
    width: 100%;
  }

  /* TOOLTIPS */
    .tooltip {
      display: block !important;
      padding: 4px;
      z-index: 20000;
    }

    .tooltip .tooltip-inner {
      background: black;
      color: white;
      border-radius: 16px;
      padding: 5px 10px 4px;
    }

    .tooltip tooltip-arrow {
      display: none;
    }

    .tooltip[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }
  /* ./TOOLTIPS */
</style>


// WEBPACK FOOTER //
// CertificadosMain.vue?e00e02cc